import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let studiesSwiperWr = document.querySelectorAll('.studies-swiper-wr');
studiesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let relatedType = el.classList.contains('related-studies-slider');

    let pagination = {
      el: paginationEl,
      clickable: true,
    }

    let breakpoints = {
      768: {
        spaceBetween: 16,
        // slidesPerView: 4,
        slidesPerView: 1,
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      1200: {
        spaceBetween: 28,
        slidesPerView: 2,
      },
      1300: {
        spaceBetween: 41,
        slidesPerView: 2,
      },
    }

    if (relatedType) {
      breakpoints = {
        768: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 28,
          slidesPerView: 2,
        },
        1300: {
          spaceBetween: 41,
          slidesPerView: 2,
        },
      }
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 12,
      slidesPerView: 1,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: paginationEl ? pagination : false,
      breakpoints: breakpoints,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on:{
      afterInit: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
        },

        resize: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
        }
      }
    });
    swiperObserver(swiper);
  }
});